/**
 * Seeded once from grantable-paths.json on 2026-10-08; edit by hand from here.
 *
 * Vault Management tools and commands.
 */

import { folder } from '../builder';

export const vaultManagement = folder('Vault Management');
export const cashCountManagement = vaultManagement.tool('Cash Count Management');
export const cashCountManagementApproveCashCount = cashCountManagement.command('Approve Cash Count');
export const cashCountManagementEditCashCount = cashCountManagement.command('Edit Cash Count');
export const cashCountManagementNewCashCount = cashCountManagement.command('New Cash Count');
export const cashCountManagementVoidPendingCashCount = cashCountManagement.command('Void Pending Cash Count');
export const cashierShiftManagement = vaultManagement.tool('Cashier Shift Management');
export const cashierShiftManagementApprove = cashierShiftManagement.command('Approve');
export const cashierShiftManagementApproveEditCreditFill = cashierShiftManagement.command('Approve/Edit Credit/Fill');
export const cashierShiftManagementApproveEditStartingBank = cashierShiftManagement.command('Approve/Edit Starting Bank');
export const cashierShiftManagementCashierShiftManagementTool = cashierShiftManagement.command(
  'Cashier Shift Management Tool',
  {
    uiOnly: true,
  },
);
export const cashierShiftManagementEdit = cashierShiftManagement.command('Edit');
export const cashierShiftManagementEditEditTransactionInClosedShift = cashierShiftManagementEdit.command('Edit Transaction In Closed Shift');
export const cashierShiftManagementEvenExchange = cashierShiftManagement.command('Even Exchange');
export const cashierShiftManagementVaultTransfer = cashierShiftManagement.command('Vault Transfer');
export const cashierShiftManagementVoidAndReEnterTransaction = cashierShiftManagement.command('Void and Re-Enter Transaction');
// The cashier-side paths below are declared so unit-14/15/17 can gate on legacy's own spellings. Cashier Fill, Cashier Credit and
// Request Fill are server-enforced by unit-14 (F-26). Void Transactions, Void Pending Transactions and Void Transactions In Closed
// Vault are server-enforced by the cashier-vault void policy (#10); Void Open Shift stays uiOnly (no Nova route voids an open shift).
export const cashierShiftManagementCashierCredit = cashierShiftManagement.command(
  'Cashier Credit',
  {
    description: 'Credit a cashier shift from the cashier shift management tool.',
  },
);
export const cashierShiftManagementCashierFill = cashierShiftManagement.command(
  'Cashier Fill',
  {
    description: 'Fill a cashier shift from the cashier shift management tool.',
  },
);
export const cashierShiftManagementMyCashierManagementTool = cashierShiftManagement.command(
  'My Cashier Management Tool',
  {
    description: 'Open the My Cashier Management tool and read its cashier-vault locations, shifts and shift summary.',
  },
);
// vault-management-completion (unit-03): the cashier shift lifecycle, Notes and Tip Drop paths, byte-identical to legacy's SecurityPath
// strings. Declared ahead of the routes that enforce them (cashier-vault-shifts, tip-drop create type, Notes), as Cashier Fill was.
export const cashierShiftManagementOpenShift = cashierShiftManagement.command(
  'Open Shift',
  {
    description: 'Open a cashier vault shift.',
  },
);
export const cashierShiftManagementOpenShiftOpenShiftZeroBank = cashierShiftManagementOpenShift.command(
  'Open Shift - Zero Bank',
  {
    description: 'Open a cashier vault shift with a zero starting bank.',
  },
);
export const cashierShiftManagementCloseShift = cashierShiftManagement.command(
  'Close Shift',
  {
    description: 'Close a cashier vault shift.',
  },
);
export const cashierShiftManagementRollShift = cashierShiftManagement.command(
  'Roll Shift',
  {
    description: 'Roll a cashier vault shift over into a new shift.',
  },
);
export const cashierShiftManagementNotes = cashierShiftManagement.command(
  'Notes',
  {
    description: 'View and add a cashier shift\'s notes (the Notes tab).',
  },
);
export const cashierShiftManagementTipDrop = cashierShiftManagement.command(
  'Tip Drop',
  {
    description: 'Create a tip drop from the cashier shift management tool.',
  },
);
export const cashierShiftManagementRequestFill = cashierShiftManagement.command(
  'Request Fill',
  {
    description: 'Request a fill from a vault for a cashier shift.',
  },
);
export const cashierShiftManagementVoidPendingTransactions = cashierShiftManagement.command(
  'Void Pending Transactions',
  {
    description: 'Void pending cashier transactions.',
  },
);
export const cashierShiftManagementVoidTransactions = cashierShiftManagement.command(
  'Void Transactions',
  {
    description: 'Void cashier transactions.',
  },
);
export const cashierShiftManagementVoidTransactionsVoidOpenShift = cashierShiftManagementVoidTransactions.command(
  'Void Open Shift',
  {
    description: 'Void a transaction on an open cashier shift.',
    uiOnly: true,
  },
);
export const cashierShiftManagementVoidTransactionsVoidTransactionsInClosedVault = cashierShiftManagementVoidTransactions.command(
  'Void Transactions In Closed Vault',
  {
    description: 'Void a cashier transaction that posted to a closed vault.',
  },
);
export const createAdjustingEntries = vaultManagement.command('Create Adjusting Entries');
export const dropAndIssueStation = vaultManagement.tool(
  'Drop & Issue Station',
  {
    description: 'Open the Drop & Issue station (declared for unit-14/15, no server route checks it yet).',
    uiOnly: true,
  },
);
export const dropAndIssueStationTipDrop = dropAndIssueStation.command(
  'Tip Drop',
  {
    description: 'Create a tip drop from the Drop & Issue station.',
  },
);
export const tipEmployeeManagement = vaultManagement.tool(
  'Tip Employee Management',
  {
    description: 'Open the Tip Employee Management tool.',
  },
);
export const tipEmployeeManagementTipDrop = tipEmployeeManagement.command(
  'Tip Drop',
  {
    description: 'Create a tip drop from the Tip Employee Management tool.',
  },
);
export const currencyBagManagement = vaultManagement.tool('Currency Bag Management');
export const currencyBagManagementApproveBag = currencyBagManagement.command('Approve Bag');
export const currencyBagManagementLoadBag = currencyBagManagement.command('Load Bag');
export const currencyBagManagementModifyBag = currencyBagManagement.command('Modify Bag');
export const currencyBagManagementShowHistory = currencyBagManagement.command('Show History');
export const currencyBagManagementUnloadBag = currencyBagManagement.command('Unload Bag');
export const machineCountManagement = vaultManagement.tool('Machine Count Management');
export const machineCountManagementEditMachineCount = machineCountManagement.command('Edit Machine Count');
export const machineCountManagementNewMachineCount = machineCountManagement.command('New Machine Count');
export const machineCountManagementNotes = machineCountManagement.command('Notes', {
  description: 'View and add a machine count\'s notes (the Notes tab).',
});
export const machineCountManagementVoidMachineCount = machineCountManagement.command('Void Machine Count');
export const tableCountManagement = vaultManagement.tool('Table Count Management');
export const tableCountManagementEditTableCount = tableCountManagement.command('Edit Table Count');
export const tableCountManagementNewTableCount = tableCountManagement.command('New Table Count');
export const tableCountManagementNotes = tableCountManagement.command('Notes', {
  description: 'View and add a table count\'s notes (the Notes tab).',
});
export const tableCountManagementVoidAndReEnterTableCount = tableCountManagement.command('Void and Re-Enter Table Count');
export const tableCountManagementUnlockCashCount = tableCountManagement.command(
  'Unlock Cash Count',
  {
    description: 'Unlock the cash count on a table count.',
    uiOnly: true,
  },
);
export const tableCountManagementVoidTableCount = tableCountManagement.command('Void Table Count');
export const vaultTransactionManagement = vaultManagement.tool('Vault Transaction Management');
export const vaultTransactionManagementAllowShowAllPending = vaultTransactionManagement.command(
  'Allow Show All Pending',
  {
    description: 'Show all pending transactions in Vault Transaction Management.',
    uiOnly: true,
  },
);
export const vaultTransactionManagementApprove = vaultTransactionManagement.command('Approve');
export const vaultTransactionManagementApproveVariance = vaultTransactionManagement.command('Approve Variance');
export const vaultTransactionManagementCloseOpenVault = vaultTransactionManagement.command('Close/Open Vault');
export const vaultTransactionManagementCriteriaSelectionVault = vaultTransactionManagement.command(
  'Criteria Selection: Vault',
  {
    description: 'Choose a vault in the Vault Transaction Management criteria.',
    uiOnly: true,
  },
);
export const vaultTransactionManagementEditTransaction = vaultTransactionManagement.command('Edit Transaction');
export const vaultTransactionManagementEditTransactionEditTransactionInClosedVault = vaultTransactionManagementEditTransaction.command('Edit Transaction In Closed Vault');
export const vaultTransactionManagementEvenExchange = vaultTransactionManagement.command('Even Exchange');
export const vaultTransactionManagementJackpotTicketPayout = vaultTransactionManagement.command('Jackpot Ticket Payout');
export const vaultTransactionManagementLogTransactions = vaultTransactionManagement.command(
  'Log Transactions',
  {
    description: 'Open the transaction log in Vault Transaction Management.',
    uiOnly: true,
  },
);
export const vaultTransactionManagementMakeBankDeposit = vaultTransactionManagement.command('Make Bank Deposit');
export const vaultTransactionManagementNotes = vaultTransactionManagement.command('Notes', {
  description: 'View and add a transaction\'s notes (the Notes tab), including a cash count\'s.',
});
export const vaultTransactionManagementOverrideVaultLocations = vaultTransactionManagement.command('Override Vault Locations');
export const vaultTransactionManagementOverrideVaultShifts = vaultTransactionManagement.command('Override Vault Shifts');
export const vaultTransactionManagementPostToClosedVault = vaultTransactionManagement.command(
  'Post to Closed Vault',
  {
    description: 'Post a transaction to a closed vault (shows the closed-vault approval step).',
    uiOnly: true,
  },
);
export const vaultTransactionManagementRightClickShowDocuments = vaultTransactionManagement.command(
  'Right Click Show Documents',
  {
    description: 'Show a transaction\'s documents from the grid context menu.',
    uiOnly: true,
  },
);
export const vaultTransactionManagementTipDrop = vaultTransactionManagement.command(
  'Tip Drop',
  {
    description: 'Create a tip drop from the vault transaction management tool.',
  },
);
export const vaultTransactionManagementTransactionsIntoVault = vaultTransactionManagement.command('Transactions Into Vault');
export const vaultTransactionManagementTransactionsOutOfVault = vaultTransactionManagement.command('Transactions Out of Vault');
export const vaultTransactionManagementVaultTransfer = vaultTransactionManagement.command('Vault Transfer');
export const vaultTransactionManagementVaultTransferVaultTransferInDarkVault = vaultTransactionManagementVaultTransfer.command('Vault Transfer in Dark Vault');
export const vaultTransactionManagementVaultTransferRequest = vaultTransactionManagement.command('Vault Transfer Request');
export const vaultTransactionManagementVaultTransferRequestAllowSelectingToVault = vaultTransactionManagementVaultTransferRequest.command('Allow Selecting To Vault');
export const vaultTransactionManagementViewTransaction = vaultTransactionManagement.command(
  'View Transaction',
  {
    description: 'View a transaction from the Vault Transaction Management grid.',
    uiOnly: true,
  },
);
export const vaultTransactionManagementVoidTransaction = vaultTransactionManagement.command('Void Transaction');
export const vaultTransactionManagementVoidTransactionVoidTransactionInClosedVault = vaultTransactionManagementVoidTransaction.command('Void Transaction In Closed Vault');
